import React, {Component} from 'react';
import {reduxForm, formValueSelector, change} from 'redux-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import PersonalInformationTab from '../../../../itrust_common/components/authorised/patientFormPartial/PersonalInformationTab'
import AddressTab from '../../../../itrust_common/components/authorised/patientFormPartial/AddressTab'
import PrimaryInsuranceTab from '../../../../itrust_common/components/authorised/patientFormPartial/PrimaryInsuranceTab'
import PrimaryPhysicianTab from '../../../../itrust_common/components/authorised/patientFormPartial/PrimaryPhysicianTab'
import TermOfServiceTab from '../../../../itrust_common/components/authorised/patientFormPartial/TermOfServiceTab'
import {CountriesStates} from '../../../../itrust_common/components/CountriesStates';
import { dateFormat, filterByKey, ternaryIsPresentInObj } from '../../../../itrust_common/components/HelperFunctions';
import { insurancePlansLoad } from '../../../../itrust_common/redux/actions/settingActions/insurancePlansActions';
import { insuranceLoad } from '../../../../itrust_common/redux/actions/settingActions/insuranceActions';
import { publicInsurancePlansLoad, publicInsuranceLoad } from '../../../../redux/actions/public/InsuranceActions';
import ScrollToTarget from '../../../../itrust_common/components/others/ScrollToTarget';
import moment from 'moment-timezone';


class PersonalInformationForm extends Component{
  copyToInsurerAddress(source, destination){
    const { insuarncePatientAddressValue } = this.props;
    var sourceObj = eval(`insuarncePatientAddressValue.${source}`);
    if(sourceObj){
      const insurenceAddressValue = sourceObj[`address1`]
      const insurenceAddress2Value = sourceObj[`address2`]
      const insurenceCountryValue = sourceObj[`country`]
      const insurenceStateValue = sourceObj[`state`]
      const insurenceCityValue = sourceObj[`city`]
      const insurenceZipCodeValue = sourceObj[`zip`]
      return [
        this.props.dispatch(change('patientForm', `${destination}[address_attributes][address1]`,insurenceAddressValue )),
        this.props.dispatch(change('patientForm', `${destination}[address_attributes][address2]`,insurenceAddress2Value )),
        this.props.dispatch(change('patientForm', `${destination}[address_attributes][country]`,insurenceCountryValue )),
        this.props.dispatch(change('patientForm', `${destination}[address_attributes][state]`,insurenceStateValue )),
        this.props.dispatch(change('patientForm', `${destination}[address_attributes][city]`,insurenceCityValue )),
        this.props.dispatch(change('patientForm', `${destination}[address_attributes][zip]`,insurenceZipCodeValue )),
      ]
    }
  }

  state = {
    visionInsurancePlans: [],
    medicalInsurancePlans: [],
    secondaryInsurancePlans: [],
    tertiaryInsurancePlans: [],
    visionTertiaryInsurancePlans: [],
    tertiaryInsurancePlans: [],
    visionInsurance: [],
    visionSecondaryInsurance: [],
    visionTertiaryInsurance: [],
    medicalInsurance: [],
    secondaryInsurance: [],
    tertiaryInsurance: [],
  }

  handleInsurancePlansLoad(filters) {
    if(localStorage.getItem('Access-Token'))
      return this.props.dispatch(insurancePlansLoad(filters));
    else return this.props.dispatch(publicInsurancePlansLoad(filters));
  }

  handleInsuranceLoad(id) {
    if (localStorage.getItem('Access-Token'))
      return this.props.dispatch(insuranceLoad(id));
    else return this.props.dispatch(publicInsuranceLoad(id));
  }

  componentDidUpdate(prevProps) {
    const { selectedVisionInsuranceId, selectedMedicalInsuranceId, selectedSecondaryInsuranceId, selectedTertiaryInsuranceId, selectedVisionSecondaryInsuranceId, selectedVisionTertiaryInsuranceId } = this.props
    if(selectedVisionInsuranceId && (selectedVisionInsuranceId !== prevProps.selectedVisionInsuranceId)) {
      this.handleInsuranceLoad(selectedVisionInsuranceId).then((res) => this.setState({ visionInsurance: res.value.data.insurance }))
      this.handleInsurancePlansLoad({rpp: 1000, filter: {is_active: true, insurance_payer: selectedVisionInsuranceId }})
        .then(res => {
          this.setState({
            visionInsurancePlans: res.value.data.insurance_plans
          })
        })
    }
    if(selectedMedicalInsuranceId && (selectedMedicalInsuranceId !== prevProps.selectedMedicalInsuranceId)) {
      this.handleInsuranceLoad(selectedMedicalInsuranceId).then((res) => this.setState({ medicalInsurance: res.value.data.insurance }))
      this.handleInsurancePlansLoad({rpp: 1000, filter: {is_active: true, insurance_payer: selectedMedicalInsuranceId }})
        .then(res => {
          this.setState({
            medicalInsurancePlans: res.value.data.insurance_plans
          })
        })
    }
    if(selectedSecondaryInsuranceId && (selectedSecondaryInsuranceId !== prevProps.selectedSecondaryInsuranceId)) {
      this.handleInsuranceLoad(selectedSecondaryInsuranceId).then((res) => this.setState({ secondaryInsurance: res.value.data.insurance }))
      this.handleInsurancePlansLoad({rpp: 1000, filter: {is_active: true, insurance_payer: selectedSecondaryInsuranceId }})
        .then(res => {
          this.setState({
            secondaryInsurancePlans: res.value.data.insurance_plans
          })
        })
    }
    if(selectedTertiaryInsuranceId && (selectedTertiaryInsuranceId !== prevProps.selectedTertiaryInsuranceId)) {
      this.handleInsuranceLoad(selectedTertiaryInsuranceId).then((res) => this.setState({ tertiaryInsurance: res.value.data.insurance }))
      this.handleInsurancePlansLoad({rpp: 1000, filter: {is_active: true, insurance_payer: selectedTertiaryInsuranceId }})
        .then(res => {
          this.setState({
            tertiaryInsurancePlans: res.value.data.insurance_plans
          })
        })
    }
    if (selectedVisionSecondaryInsuranceId && (selectedVisionSecondaryInsuranceId !== prevProps.selectedVisionSecondaryInsuranceId)) {
      this.handleInsuranceLoad(selectedVisionSecondaryInsuranceId).then((res) => this.setState({ visionSecondaryInsurance: res.value.data.insurance }))
      this.handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedVisionSecondaryInsuranceId } })
        .then(res => {
          this.setState({
            visionSecondaryInsurancePlans: res.value.data.insurance_plans
          })
        })
    }
    if (selectedVisionTertiaryInsuranceId && (selectedVisionTertiaryInsuranceId !== prevProps.selectedVisionTertiaryInsuranceId)) {
      this.handleInsuranceLoad(selectedVisionTertiaryInsuranceId).then((res) => this.setState({ visionTertiaryInsurance: res.value.data.insurance }))
      this.handleInsurancePlansLoad({ rpp: 1000, filter: { is_active: true, insurance_payer: selectedVisionTertiaryInsuranceId } })
        .then(res => {
          this.setState({
            visionTertiaryInsurancePlans: res.value.data.insurance_plans
          })
        })
    }
  }

  render(){
    const { isLongForm, handleSubmit, template, patientRelationship, primaryInsurerSelectedCountry, primaryInsurerRegions, homeSelectedCountry, homeRegions, officeSelectedCountry, officeRegions, selectedVisionInsuranceId, selectedMedicalInsuranceId, selectedSecondaryInsuranceId, selectedTertiaryInsuranceId, selectedVisionSecondaryInsuranceId, selectedVisionTertiaryInsuranceId, insurance} = this.props
    return (
      <form onSubmit={handleSubmit}>
        <div id="patient-personal-tab">
          <PersonalInformationTab template={template} isTemplate={false} isLongForm={isLongForm}
            primaryInsurerSelectedCountry={primaryInsurerSelectedCountry} primaryInsurerRegions={primaryInsurerRegions}
            homeSelectedCountry={homeSelectedCountry} homeRegions={homeRegions}
            officeSelectedCountry={officeSelectedCountry} officeRegions={officeRegions}
            />
        </div>
        {
          isLongForm===true &&
          <div id="patient-address-tab">
            <AddressTab template={template} isTemplate={false}
              primaryInsurerSelectedCountry={primaryInsurerSelectedCountry} primaryInsurerRegions={primaryInsurerRegions}
              homeSelectedCountry={homeSelectedCountry} homeRegions={homeRegions}
              officeSelectedCountry={officeSelectedCountry} officeRegions={officeRegions}
              />
          </div>
        }
          <div id="patient-primary-insurance-tab">
          <PrimaryInsuranceTab template={template} isTemplate={false} isLongForm={isLongForm} patientRelationship={patientRelationship}
            primaryInsurerSelectedCountry={primaryInsurerSelectedCountry} primaryInsurerRegions={primaryInsurerRegions}
            copyToInsurerAddress={this.copyToInsurerAddress.bind(this)}
            homeSelectedCountry={homeSelectedCountry} homeRegions={homeRegions}
            officeSelectedCountry={officeSelectedCountry} officeRegions={officeRegions}
            visionInsurancePlans={this.state.visionInsurancePlans} medicalInsurancePlans={this.state.medicalInsurancePlans}
            insurance={insurance}
            secondaryInsurancePlans={this.state.secondaryInsurancePlans}
            tertiaryInsurancePlans={this.state.tertiaryInsurancePlans}
            selectedVisionInsuranceId={selectedVisionInsuranceId}
            selectedVisionSecondaryInsuranceId={selectedVisionSecondaryInsuranceId}
            selectedVisionTertiaryInsuranceId={selectedVisionTertiaryInsuranceId}
            visionSecondaryInsurancePlans={this.state.visionSecondaryInsurancePlans}
            visionTertiaryInsurancePlans={this.state.visionTertiaryInsurancePlans}
            selectedMedicalInsuranceId={selectedMedicalInsuranceId}
            selectedSecondaryInsuranceId={selectedSecondaryInsuranceId}
            selectedTertiaryInsuranceId={selectedTertiaryInsuranceId}
            selectedVisionInsurance={this.state.visionInsurance}
            selectedMedicalInsurance={this.state.medicalInsurance}
            selectedSecondaryInsurance={this.state.secondaryInsurance}
            selectedTertiaryInsurance={this.state.tertiaryInsurance}
            selectedVisionSecondaryInsurance={this.state.visionSecondaryInsurance}
            selectedVisionTertiaryInsurance={this.state.visionTertiaryInsurance}
          />

          </div>
        {
          isLongForm===true &&
          [
          <div id="patient-primary-physician-tab">
            <PrimaryPhysicianTab template={template} isTemplate={false}
              primaryInsurerSelectedCountry={primaryInsurerSelectedCountry} primaryInsurerRegions={primaryInsurerRegions}
              homeSelectedCountry={homeSelectedCountry} homeRegions={homeRegions}
              officeSelectedCountry={officeSelectedCountry} officeRegions={officeRegions}
              />
          </div>,
          <div id="patient-term-of-service-tab">
            <TermOfServiceTab template={template} isTemplate={false}
              primaryInsurerSelectedCountry={primaryInsurerSelectedCountry} primaryInsurerRegions={primaryInsurerRegions}
              homeSelectedCountry={homeSelectedCountry} homeRegions={homeRegions}
              officeSelectedCountry={officeSelectedCountry} officeRegions={officeRegions}
              />
          </div>]
        }
      </form>
    );
  }
}

PersonalInformationForm = reduxForm({
  form: 'patientForm',
  enableReinitialize: true,
  shouldValidate: () => true,
  onSubmitFail: (errors) => { ScrollToTarget()}
})(PersonalInformationForm)

const selector = formValueSelector('patientForm');

PersonalInformationForm = connect(state => {
  const { patient } = state.patient
  const { patient_template } = state.setting.patientTemplate
  const { insurances, insurance } = state.setting.insurance
  const { organisation: { organisation } } = state
  const patientAddress = patient.home_address_attributes
  const organisationAddress = organisation.address_attributes
  const primaryInsurerCountryData = _.find(CountriesStates, { countryName: selector(state, 'primary_insurer[address_attributes][country]') })
  const homeCountryData = _.find(CountriesStates, { countryName: selector(state, 'home_address_attributes[country]') })
  const officeCountryData = _.find(CountriesStates, { countryName: selector(state, 'office_address_attributes[country]') })

  const selectedVisionInsuranceId = selector(state, 'patient_vision_insurance_attributes[settings_insurance_id]')
  const selectedVisionSecondaryInsuranceId = selector(state, 'patient_vision_secondary_insurance_attributes[settings_insurance_id]')
  const selectedVisionTertiaryInsuranceId = selector(state, 'patient_vision_tertiary_insurance_attributes[settings_insurance_id]')
  const selectedMedicalInsuranceId = selector(state, 'patient_medical_insurance_attributes[settings_insurance_id]')
  const selectedSecondaryInsuranceId = selector(state, 'patient_secondary_insurance_attributes[settings_insurance_id]')
  const selectedTertiaryInsuranceId = selector(state, 'patient_tertiary_insurance_attributes[settings_insurance_id]')

  const patientRelationship = selector(state, 'relation_to_insured')
  const insuarncePatientAddressValue = selector(state, 'home_address_attributes', 'primary_insurer')
  // formate recall_reminder_date so, that it can be shown prefill
  patient.recall_reminder_date = patient.recall_reminder_date ? moment(patient.recall_reminder_date).format("YYYY/MM/DD") : patient.recall_reminder_date;
  return {
    insurance,
    insuarncePatientAddressValue,
    primaryInsurerSelectedCountry: primaryInsurerCountryData && primaryInsurerCountryData.countryName,
    primaryInsurerRegions: primaryInsurerCountryData ? primaryInsurerCountryData.regions : [],
    homeSelectedCountry: homeCountryData && homeCountryData.countryName,
    homeRegions: homeCountryData ? homeCountryData.regions : [],
    officeSelectedCountry: officeCountryData && officeCountryData.countryName,
    officeRegions: officeCountryData ? officeCountryData.regions : [],
    template: patient_template,
    patientRelationship: patientRelationship,
    selectedVisionInsuranceId,
    selectedVisionSecondaryInsuranceId,
    selectedVisionTertiaryInsuranceId,
    selectedMedicalInsuranceId,
    selectedSecondaryInsuranceId,
    selectedTertiaryInsuranceId,
    initialValues: {
      ...patient,
      // pending_signup: false,
      home_address_attributes: {
        ...patientAddress,
        country: ternaryIsPresentInObj(patientAddress, 'country', organisationAddress, 'country'),
        state: ternaryIsPresentInObj(patientAddress, 'state', organisationAddress, 'state'),
      }
    }
  }
})(PersonalInformationForm)

export default PersonalInformationForm;
